// existing imports
import { initializeApp } from 'firebase/app';
import {
  getAuth,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut as firebaseSignOut,
  // ⬇️ ADDED
  GoogleAuthProvider,
  signInWithPopup
} from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyC_Smw-73om47fuKrTRt9uGp21lwfCxwM8",
  authDomain: "reverieon-ai.firebaseapp.com",
  projectId: "reverieon-ai",
  storageBucket: "reverieon-ai.appspot.com",
  messagingSenderId: "1009404324264",
  appId: "1:1009404324264:web:64fa621a65541f42b6d59d",
  measurementId: "G-WHLJ9Y07J7"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

// ⬇️ ADDED: Google provider (use a single shared instance)
const googleProvider = new GoogleAuthProvider();

// existing export + ⬇️ ADDED exports
export {
  auth,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  firebaseSignOut as signOut,
  // ⬇️ ADDED
  googleProvider,
  signInWithPopup
};